const initialSate = {
  collegeStates: [],
  schoolStates: [],
  city: [],
  county: [],
  schools: [],
  college: [],
};

const authDataReducer = (state = initialSate, action) => {
  switch (action.type) {
    case "GET_COLLEGE_STATES":
      return {
        ...state,
        collegeStates: action.payload,
      };
    case "GET_SCHOOL_STATES":
      return {
        ...state,
        schoolStates: action.payload,
      };
    case "GET_CITY_BY_STATE":
      return {
        ...state,
        city: action.payload,
      };
    case "GET_COUNTY_BY_STATE":
      return {
        ...state,
        county: action.payload,
      };
    case "GET_SCHOOL_BY_STATE_AND_COUNTY":
      return {
        ...state,
        schools: action.payload,
      };
    case "GET_COLLEGE_NAME_BY_STATE_AND_CITY":
      return {
        ...state,
        college: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default authDataReducer;
